export default {
  modalState: false,
  modalContent: {},
  modalProps: {},
  modalSize: '50%',
  modalClass: '',
  modalCloseOnClick: true,
  modalShowClose: true,
  modalCloseOnPressEscape: true,
  modalButtonLoading: false,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/modal/state.js